import { Tabs, TabsTrigger } from "@/components/ui/tabs";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { TabsList } from "@radix-ui/react-tabs";
import { isNumber } from "lodash-es";
import { EducationAndQualificationType } from "../-zod-schema";
import { useCertificationsCountQuery } from "../certification/-query";

type EducationAndQualificationTabsProps = {
  personId?: string;
};

export function EducationAndQualificationTabs({
  personId,
}: EducationAndQualificationTabsProps) {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.person.profile.educationsAndQualifications",
  });

  const { data: certifications } = useCertificationsCountQuery({
    personId,
  });

  const tabToQuantity = {
    [EducationAndQualificationType.CERTIFICATION]: certifications?.count,
  };

  const tabToLabel = {
    [EducationAndQualificationType.CERTIFICATION]: t("tabs.certification"),
  };

  return (
    <Tabs value={EducationAndQualificationType.CERTIFICATION}>
      <TabsList className="flex gap-4 p-0">
        {[EducationAndQualificationType.CERTIFICATION].map((tab) => (
          <TabsTrigger
            key={tab}
            value={tab}
            className="h-8 gap-2 data-[state=active]:shadow-none"
          >
            {tabToLabel[tab]}
            {isNumber(tabToQuantity[tab]) && (
              <span className="ml-1 text-xs animate-in fade-in">
                {tabToQuantity[tab]}
              </span>
            )}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
